'use client';

import type { ReactNode } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { AgimaLogo } from '@/components/brand/AgimaLogo';
import { ThemeToggle } from '@/components/ThemeToggle';
import styles from './AgimaEntryShell.module.css';

type AgimaEntryShellProps = {
  children: ReactNode;
  kicker?: string;
  title?: string;
  subtitle?: string;
  wide?: boolean;
  prejoin?: boolean;
  showAdminLink?: boolean;
};

export function AgimaEntryShell({
  children,
  kicker,
  title,
  subtitle,
  wide,
  prejoin,
  showAdminLink = true,
}: AgimaEntryShellProps) {
  return (
    <div className={styles.shell}>
      <Image
        className={styles.bg}
        src="/images/agima-entry.jpg"
        alt=""
        fill
        priority
        sizes="100vw"
      />
      <div className={styles.veil} />
      <header className={styles.top}>
        <Link className={styles.brand} href="/" target="_blank" rel="noopener">
          <AgimaLogo className={styles.logo} />
          <span className={styles.product}>Meet</span>
        </Link>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {showAdminLink ? (
            // /admin is served by octor-backend, not a Next.js route.
            // eslint-disable-next-line @next/next/no-html-link-for-pages
            <a className={styles.navLink} href="/admin/" target="_blank" rel="noopener">
              Админка
            </a>
          ) : null}
          <ThemeToggle />
        </div>
      </header>
      <div className={styles.stage}>
        <section
          className={`${styles.card} ${wide ? styles.wide : ''} ${prejoin ? styles.prejoin : ''}`}
        >
          {kicker ? <p className={styles.kicker}>{kicker}</p> : null}
          {title ? <h1 className={styles.title}>{title}</h1> : null}
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          {children}
        </section>
      </div>
    </div>
  );
}

export { styles as entryStyles };
